// extracted by mini-css-extract-plugin
export default {"mobile":"CarModal_mobile__WJ6FT"};